
export const phoneRegex = /^(?:(?:(?:00|\+)?218)|0)?([9][1-5][0-9]{7})$/;
export const passportRegex = /^[A-Z0-9a-z]{8}$/;
export const nationalIdRegex = /^[12][0-9]{11}$/;
